import React from "react";
import SectionTitle from "./common/SectionTitle";

const values = [
	{
		icon: "fas fa-lightbulb",
		title: "Innovation",
		description:
			"We constantly push boundaries to deliver cutting-edge solutions that give our clients a competitive edge.",
	},
	{
		icon: "fas fa-handshake",
		title: "Integrity",
		description:
			"We build trust through transparency, honesty, and ethical business practices in all our relationships.",
	},
	{
		icon: "fas fa-bullseye",
		title: "Excellence",
		description:
			"We strive for perfection in everything we do, delivering quality that exceeds expectations.",
	},
	{
		icon: "fas fa-users",
		title: "Collaboration",
		description:
			"We believe in the power of teamwork, both within our organization and with our clients.",
	},
	{
		icon: "fas fa-heart",
		title: "Passion",
		description:
			"We love what we do, and this enthusiasm fuels our creativity and dedication.",
	},
	{
		icon: "fas fa-chart-line",
		title: "Growth",
		description:
			"We are committed to continuous improvement and helping our clients grow their businesses.",
	},
];

const Values = () => {
	return (
		<section className="values">
			<div className="container">
				<SectionTitle
					title="Our Core Values"
					subtitle="The principles that guide everything we do"
				/>

				<div className="values-grid">
					{values.map((value, index) => (
						<div key={index} className="value-card">
							<div className="value-icon">
								<i className={value.icon}></i>
							</div>
							<h3>{value.title}</h3>
							<p>{value.description}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Values;
